import React, { Component } from 'react';
import { isEqual } from 'lodash';
import { withTheme } from 'styled-components';
import helpers from 'helpers';
import PropTypes from 'prop-types';
import DonutChart from 'components/molecules/charts/DonutChart';

class ChannelDonutChart extends Component {
    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps.data, this.props.data) || !isEqual(nextProps.total, this.props.total);
    }

    render() {
        const { data, enabledChannels, ...props } = this.props;
        const { orderedColors } = this.props.theme;

        const seriesData = [];

        helpers.orderedChannelKeys(enabledChannels).forEach((n, index) => {
            if (!data[n]) {
                return;
            }

            seriesData.push({
                name: helpers.convertToDisplayValue(n),
                y: data[n],
                color: orderedColors[index % orderedColors.length]
            });
        });

        return (
            <DonutChart {...props}
                data={seriesData} />
        );
    }
}

ChannelDonutChart.propTypes = {
    enabledChannels: PropTypes.arrayOf(PropTypes.string).isRequired,
    data: PropTypes.shape({
        mobile: PropTypes.number,
        display: PropTypes.number,
        sem: PropTypes.number
    }).isRequired,
};

export default withTheme(ChannelDonutChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/ChannelDonutChart.js